/* Amy Lucy v1.6: indicative dates shown beside product/cart actions. */
(() => {
  if(window.__amyLucyGiftDeliveryInit)return;
  window.__amyLucyGiftDeliveryInit=true;
  const holidayDates = new Set([
    '2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28',
    '2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28',
    '2028-01-03','2028-04-14','2028-04-17','2028-05-01','2028-05-29','2028-08-28','2028-12-25','2028-12-26'
  ]);
  const key = (d) => [d.getUTCFullYear(),String(d.getUTCMonth()+1).padStart(2,'0'),String(d.getUTCDate()).padStart(2,'0')].join('-');
  const todayInLondon = () => {
    const parts = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const values = Object.fromEntries(parts.map((p)=>[p.type,p.value]));
    return new Date(Date.UTC(+values.year,+values.month-1,+values.day,12));
  };
  const isDispatchDay = (d) => d.getUTCDay() > 0 && d.getUTCDay() < 6 && !holidayDates.has(key(d));
  const isDeliveryDay = (d) => d.getUTCDay() !== 0 && !holidayDates.has(key(d));
  const addDays = (start,count,accept) => {
    const d = new Date(start.getTime());
    let n=0;
    while(n<count){d.setUTCDate(d.getUTCDate()+1);if(accept(d))n++;}
    return d;
  };
  const formatDay = (date) => new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'short',day:'numeric',month:'short'}).format(date);
  const applyDates = () => {
    const blocks = document.querySelectorAll('[data-al-gift-delivery]');
    if (!blocks.length) return;
    const country = String(window.Shopify?.country || '').toUpperCase();
    if (country && country !== 'GB') {
      blocks.forEach((block) => {
        const uk = block.querySelector('[data-al-gift-delivery-uk]');
        const international = block.querySelector('[data-al-gift-delivery-international]');
        if(uk)uk.hidden=true;
        if(international)international.hidden=false;
      });
      return;
    }
    const today = todayInLondon();
    // Use dated estimates only while the verified bank-holiday calendar covers the full window.
    if(today.getUTCFullYear()<2026 || today.getUTCFullYear()>2028)return;
    const dispatch = addDays(today,1,isDispatchDay);
    const express = addDays(dispatch,1,isDeliveryDay);
    const standardStart = addDays(dispatch,2,isDeliveryDay);
    const standardEnd = addDays(dispatch,3,isDeliveryDay);
    if(standardEnd.getUTCFullYear()>2028)return;
    blocks.forEach((block) => {
      const update = (selector,value) => {
        const node=block.querySelector(selector);
        if(node && node.textContent!==value)node.textContent=value;
      };
      update('[data-al-dispatch-date]',formatDay(dispatch));
      update('[data-al-express-date]',formatDay(express));
      update('[data-al-standard-date]',formatDay(standardStart)+' – '+formatDay(standardEnd));
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',applyDates,{once:true});
  else applyDates();
  document.addEventListener('shopify:section:load',applyDates);
  // Shopify replaces mini-cart contents after cart updates. Reapply dates to new panels.
  if(window.MutationObserver){
    const observe = () => {
      if(!document.body)return;
      let pending=false;
      const watcher = new MutationObserver((records) => {
        const added = records.some((record)=>Array.from(record.addedNodes).some((node)=>
          node.nodeType===1 && (node.matches?.('[data-al-gift-delivery]')||node.querySelector?.('[data-al-gift-delivery]'))
        ));
        if(added && !pending){
          pending=true;
          window.requestAnimationFrame(()=>{pending=false;applyDates();});
        }
      });
      watcher.observe(document.body,{childList:true,subtree:true});
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observe,{once:true});
    else observe();
  }
})();
